export default __webpack_public_path__ + "static/Golden_sky-f509d50ddcbcc4211b0c25b44f89cb9c.png";